import {animate, group, keyframes, query, state, style, transition, trigger} from '@angular/animations';

/* route slide effect */
const resetRoute = [
  query(
    ':enter, :leave',
    [
      style({
        position: 'absolute',
        top: 0,
        transform: 'translateX(150%)'

      }),
    ],
    {optional: true}
  ),
];

/* Utilisé sur /list en version mobile */
export const slideFromBotOutside =
  trigger('slideFromBotOutside', [
    transition(':enter', [
      style({'bottom': '-300px',}),
      animate('250ms ease-in-out', style({'bottom': '{{bottom_value}}'})),
    ]),
    transition(':leave', [
      style({'bottom': '{{bottom_value}}',}),
      animate('250ms', style({'bottom': '-300px',}))
    ])
  ]);

export const routeAnim =
  trigger('routeFadeAnimation', [
    transition('* => *', [
      ...resetRoute,
      query(':enter', [style({transform: 'translateX(150%)'})], {
        optional: true,
      }),
      group([
        query(
        ':leave',
        [
          style({ transform : 'translateX(0%)' }),
          animate('0.5s',
            style({ transform : 'translateX(-150%)' }))],
        { optional: true }
      ),
      query(
        ':enter',
        [
          style({ transform : 'translateX(150%)' }),
          animate('0.6s',
            style({ transform : 'translateX(0%)'}))],
        { optional: true }
      ),
    ]),
  ]),
]);


/* Page slider animations ( both direction ) */
export const silderAnimation =
  trigger('slider', [
    transition(':increment', group([
      query(':enter', [
        style({ transform: 'translateX(120%)' }),
        animate('0.5s ease-out', style({transform: 'translateX(0)'}))
      ]),
      query(':leave', [
        animate('0.5s ease-out', style({transform: 'translateX(-120%)'}))
      ])
    ])),
    transition(':decrement', group([
      query(':enter', [
        style({
          transform: 'translateX(-120%)'
        }),
        animate('0.5s ease-out', style({transform: 'translateX(0)'}))
      ]),
      query(':leave', [
        animate('0.5s ease-out', style({transform: 'translateX(120%)'}))
      ])
    ]))
  ]);

/* fade animation */
export const fadeAnimation =
  trigger('fadeAnimation', [
    state('in', style({opacity: 1})),
    transition(':enter', [
      style({opacity: 0}),
      animate(600 )
    ]),
    transition(':leave',
      animate(800, style({opacity: 0})))
  ]);


// slide in from bottom animation
export const slideBottomAnimation =
  trigger('slideBottomAnimation', [
    transition(':enter', [
      style({'margin-top': '6rem','margin-bottom': '4rem', opacity: 0}),
      animate('800ms ease-in-out', style({'margin-top': '3rem','margin-bottom': '0.5rem', opacity: 1})),
    ]),
    transition(':leave', [
      animate('500ms', style({opacity:0}))
    ])
  ]);


/**
 * Animation utilisée dans les modales pour switch la height auto
 */
export const modalAnimation = [
  trigger('slider', [

    transition(':increment', group([

      query(':enter', [
        style({'margin-right': '100%', 'max-height': 0, overflow: 'hidden'}),
        animate('650ms ease-in-out',
          keyframes([
            style({'max-height': '300px', overflow: 'hidden', offset: 0}),
            style({'max-height': '600px', overflow: 'hidden', offset: 0.5}),
            style({'margin-right': '0', offset: 1}),
          ])
        )
      ]),

      query(':leave', [
        style({'margin-left': '0', 'max-height': '600px'}),
        animate('600ms 0.2s ease-in-out',
          keyframes([
            style({'margin-left': '-100%', offset: 0.6}),
            style({'max-height': '300px', overflow: 'hidden', offset: 0.8}),
            style({'max-height': '0', overflow: 'hidden', offset: 1}),
          ])
        )
      ]),
    ])),

    transition(':decrement', group([

      query(':enter', [
        style({'margin-left': '-100%', 'max-height': 0, overflow: 'hidden'}),
        animate('600ms ease-in-out',
          keyframes([
            style({'max-height': '300px', overflow: 'hidden', offset: 0}),
            style({'max-height': '600px', overflow: 'hidden', offset: 0.5}),
            style({'margin-left': '0', offset: 1}),
          ])
        )
      ]),

      query(':leave', [
        style({'margin-right': '0', 'max-height': '600px'}),
        animate('650ms 0.3s ease-in-out',
          keyframes([
            style({'margin-right': '100%', offset: 0}),
            style({'max-height': '300px', overflow: 'hidden', offset: 0.6}),
            style({'max-height': '0', overflow: 'hidden', offset: 1}),

          ])
        )
      ]),
    ]))
  ]),
]
